import { bindable, containerless } from 'aurelia-framework';

@containerless
export class DynamicTableRow {
  @bindable edit: boolean = false;
  constructor() {}
}
